import {
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ScatterChart,
  Cell,
  ReferenceLine,
  Scatter,
} from "recharts";
import React from "react";
import Box from "@mui/material/Box";
import {
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { CustomLegend, COLORS, legendColors, KEY} from './utils/ChartUtils'
import { isAppleWebKit, sampleData } from './utils/safariUtils'

const isSafari = isAppleWebKit();

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};


const renderTooltip = (props: any) => {
    const { active, payload } = props;
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <div
          style={{
            backgroundColor: '#fff',
            border: '1px solid #999',
            margin: 0,
            padding: 10,
          }}
        >
          <p><strong>{data.payload.release_speed.toFixed(1)+" mph "+KEY[data.payload.pitch_type_abbrev]}</strong></p>
          <p>Horizontal: {data.payload.horizontal_break.toFixed(1)} in</p>
          <p>Vertical: {data.payload.induced_vertical_break.toFixed(1)} in</p>
        </div>
      );
    }
    return null;
  };

export default function MovementProfile(props: any) {
  const chartData = isSafari ? sampleData(props.pitchData, 500) : props.pitchData;
  console.log("Pitch Data: ", props.pitchData);
  console.log("Chart Data: ", chartData);
  return (
      <Grid item maxWidth="90vw">
        <Box
          sx={{
            maxWidth: "90vw",
            width: "500px",
            border: "#293241 solid 2px",
            backgroundColor: "#FFFFFF",
            height: "100%",
            boxShadow:
              "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
          }}
          justifyContent="flex-start"
          alignItems="center"
          display="flex"
          flexDirection="column"
        >
          <div
            style={{
              width: "100%",
              paddingTop: "10px",
              paddingBottom: "10px",
              backgroundColor:
                props.playerDataProp.MLB_AbbName !== null
                  ? teamColors[props.playerDataProp.MLB_AbbName][0]
                  : teamColors["FA"][0],
            }}
          >
            {props.isDesktop &&
              (<Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5">
                  <span
                    style={{
                      color:
                        props.playerDataProp.MLB_AbbName !== null
                          ? teamColors[
                          props.playerDataProp.MLB_AbbName
                          ][1]
                          : teamColors["FA"][1],
                      fontWeight: "bold",
                      fontSize: "25pt",
                      textAlign: "center"
                    }}
                  >
                    Pitch Movement
                  </span>
                </Typography>
              </Grid>)}
            {!props.isDesktop &&
              (<Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              ><Typography variant="h5" style={{ fontSize: "25pt" }}>
                  <div
                    style={{
                      color:
                        props.playerDataProp.MLB_AbbName !== null
                          ? teamColors[
                          props.playerDataProp.MLB_AbbName
                          ][1]
                          : teamColors["FA"][1],
                      fontWeight: "bold",
                    }}
                  >
                    Pitch Movement
                  </div>
                </Typography></Grid>)}
          </div>
          <ScatterChart
            width={props.isDesktop ? 400 : 350}
            height={props.isDesktop ? 400 : 350}
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: 20,
            }}
          >
            <CartesianGrid />
            <XAxis
              type="number"
              dataKey="pfx_x"
              name="Horizontal Break"
              unit="in"
              domain={[-30, 30]}
            />
            <YAxis
              type="number"
              dataKey="pfx_z"
              name="Vertical Break"
              unit="in"
              domain={[-30, 30]}
            />
            <Tooltip cursor={{ strokeDasharray: "3 3" }} />
            <Scatter
              name="Pitch Movement"
              data={chartData}
              fill="#8884d8"
              isAnimationActive={!isSafari}
            >
              {chartData.map((p: any, index: any) => (
                <Cell key={`cell-${index}`} fill={COLORS[p.pitch_type]} />
              ))}
            </Scatter>
            <Tooltip
                cursor={{ strokeDasharray: "3 3" }}
                content={renderTooltip}

            />
            <ReferenceLine y={0} stroke="#000000" />
            <ReferenceLine x={0} stroke="#000000" />
            <ReferenceLine
              segment={[
                {
                  x: 0,
                  y: 0,
                },
                {
                  x: 0,
                  y: 0,
                },
              ]}
            />
          </ScatterChart>
          <CustomLegend colors={legendColors.filter((color) => {
            return props.pitches.includes(color["key"])
          })} />
        </Box>
      </Grid>
  );
}